import { mediaQueries } from './mediaQueries';
import { css } from '@emotion/react';
import { boxShadowStyles } from './boxShadowStyles';
import { linkStyle } from './linkStyle';
import { textStyle } from './textStyle';

export const global = css`
  body,
  pre {
    font-family: 'Helvetica Neue', Helvetica, 'Segoe UI', 'Hiragino Sans', 'メイリオ',
      'Meiryo, Osaka', 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
    ${textStyle('m', 'regular')}
  }

  a {
    ${linkStyle()}
  }

  html,
  body,
  /* Next.js */
  #__next,
  /* Storybook */
  #root {
    height: 100%;
  }

  input:focus,
  textarea:focus {
    outline: none;

    ${boxShadowStyles.outerNormal};
  }

  /* NOTE: 印刷時にスクロールバーが表示されないようにする */
  ${mediaQueries.print} {
    body: {
      overflow-y: hidden;
    }
  }
`;
